export const countryList = [
  { name: "Burkina Faso", phoneCode: "+226", timeZone: "UTC" },
  { name: "Faroe Islands", phoneCode: "+298", timeZone: "UTC" },
  { name: "Gambia", phoneCode: "+220", timeZone: "UTC" },
  { name: "Ghana", phoneCode: "+233", timeZone: "UTC" },
  { name: "Greenland", phoneCode: "+299", timeZone: "UTC" },
  { name: "Guernsey", phoneCode: "+44-1481", timeZone: "UTC" },
  { name: "Guinea", phoneCode: "+224", timeZone: "UTC" },
  { name: "Guinea-Bissau", phoneCode: "+245", timeZone: "UTC" },
  { name: "Iceland", phoneCode: "+354", timeZone: "UTC" },
  { name: "Ireland", phoneCode: "+353", timeZone: "UTC" },
  { name: "Isle of Man", phoneCode: "+44-1624", timeZone: "UTC" },
  { name: "Jersey", phoneCode: "+44-1534", timeZone: "UTC" },
  { name: "Liberia", phoneCode: "+231", timeZone: "UTC" },
  { name: "Mali", phoneCode: "+223", timeZone: "UTC" },
  { name: "Mauritania", phoneCode: "+222", timeZone: "UTC" },
  { name: "Morocco", phoneCode: "+212", timeZone: "UTC" },
  { name: "Saint Helena", phoneCode: "+290", timeZone: "UTC" },
  { name: "Sao Tome and Principe", phoneCode: "+239", timeZone: "UTC" },
  { name: "Senegal", phoneCode: "+221", timeZone: "UTC" },
  { name: "Sierra Leone", phoneCode: "+232", timeZone: "UTC" },
  { name: "Togo", phoneCode: "+228", timeZone: "UTC" },
  { name: "United Kingdom", phoneCode: "+44", timeZone: "UTC" },
  { name: "Albania", phoneCode: "+355", timeZone: "UTC +01:00" },
  { name: "Algeria", phoneCode: "+213", timeZone: "UTC +01:00" },
  { name: "Andorra", phoneCode: "+376", timeZone: "UTC +01:00" },
  { name: "Angola", phoneCode: "+244", timeZone: "UTC +01:00" },
  { name: "Austria", phoneCode: "+43", timeZone: "UTC +01:00" },
  { name: "Belgium", phoneCode: "+32", timeZone: "UTC +01:00" },
  { name: "Benin", phoneCode: "+229", timeZone: "UTC +01:00" },
  {
    name: "Bosnia and Herzegovina",
    phoneCode: "+387",
    timeZone: "UTC +01:00",
  },
  { name: "Cameroon", phoneCode: "+237", timeZone: "UTC +01:00" },
  {
    name: "Central African Republic",
    phoneCode: "+236",
    timeZone: "UTC +01:00",
  },
  { name: "Chad", phoneCode: "+235", timeZone: "UTC +01:00" },
  { name: "Croatia", phoneCode: "+385", timeZone: "UTC +01:00" },
  { name: "Czech Republic", phoneCode: "+420", timeZone: "UTC +01:00" },
  {
    name: "Democratic Republic of the Congo",
    phoneCode: "+243",
    timeZone: "UTC +01:00",
  },
  { name: "Denmark", phoneCode: "+45", timeZone: "UTC +01:00" },
  { name: "Equatorial Guinea", phoneCode: "+240", timeZone: "UTC +01:00" },
  { name: "France", phoneCode: "+33", timeZone: "UTC +01:00" },
  { name: "Gabon", phoneCode: "+241", timeZone: "UTC +01:00" },
  { name: "Germany", phoneCode: "+49", timeZone: "UTC +01:00" },
  { name: "Gibraltar", phoneCode: "+350", timeZone: "UTC +01:00" },
  { name: "Hungary", phoneCode: "+36", timeZone: "UTC +01:00" },
  { name: "Italy", phoneCode: "+39", timeZone: "UTC +01:00" },
  { name: "Liechtenstein", phoneCode: "+423", timeZone: "UTC +01:00" },
  { name: "Luxembourg", phoneCode: "+352", timeZone: "UTC +01:00" },
  { name: "Macedonia", phoneCode: "+389", timeZone: "UTC +01:00" },
  { name: "Malta", phoneCode: "+356", timeZone: "UTC +01:00" },
  { name: "Monaco", phoneCode: "+377", timeZone: "UTC +01:00" },
  { name: "Montenegro", phoneCode: "+382", timeZone: "UTC +01:00" },
  { name: "Netherlands", phoneCode: "+31", timeZone: "UTC +01:00" },
  { name: "Netherlands Antilles", phoneCode: "+599", timeZone: "UTC +01:00" },
  { name: "Niger", phoneCode: "+227", timeZone: "UTC +01:00" },
  { name: "Nigeria", phoneCode: "+234", timeZone: "UTC +01:00" },
  { name: "Norway", phoneCode: "+47", timeZone: "UTC +01:00" },
  { name: "Poland", phoneCode: "+48", timeZone: "UTC +01:00" },
  { name: "San Marino", phoneCode: "+378", timeZone: "UTC +01:00" },
  { name: "Serbia", phoneCode: "+381", timeZone: "UTC +01:00" },
  { name: "Slovakia", phoneCode: "+421", timeZone: "UTC +01:00" },
  { name: "Slovenia", phoneCode: "+386", timeZone: "UTC +01:00" },
  { name: "Spain", phoneCode: "+34", timeZone: "UTC +01:00" },
  {
    name: "Svalbard and Jan Mayen",
    phoneCode: "+47",
    timeZone: "UTC +01:00",
  },
  { name: "Sweden", phoneCode: "+46", timeZone: "UTC +01:00" },
  { name: "Switzerland", phoneCode: "+41", timeZone: "UTC +01:00" },
  { name: "Tunisia", phoneCode: "+216", timeZone: "UTC +01:00" },
  { name: "Botswana", phoneCode: "+267", timeZone: "UTC +02:00" },
  { name: "Bulgaria", phoneCode: "+359", timeZone: "UTC +02:00" },
  { name: "Burundi", phoneCode: "+257", timeZone: "UTC +02:00" },
  { name: "Cyprus", phoneCode: "+357", timeZone: "UTC +02:00" },
  { name: "Egypt", phoneCode: "+20", timeZone: "UTC +02:00" },
  { name: "Estonia", phoneCode: "+372", timeZone: "UTC +02:00" },
  { name: "Finland", phoneCode: "+358", timeZone: "UTC +02:00" },
  { name: "Greece", phoneCode: "+30", timeZone: "UTC +02:00" },
  { name: "Israel", phoneCode: "+972", timeZone: "UTC +02:00" },
  { name: "Latvia", phoneCode: "+371", timeZone: "UTC +02:00" },
  { name: "Lebanon", phoneCode: "+961", timeZone: "UTC +02:00" },
  { name: "Lesotho", phoneCode: "+266", timeZone: "UTC +02:00" },
  { name: "Libya", phoneCode: "+218", timeZone: "UTC +02:00" },
  { name: "Lithuania", phoneCode: "+370", timeZone: "UTC +02:00" },
  { name: "Malawi", phoneCode: "+265", timeZone: "UTC +02:00" },
  { name: "Moldova", phoneCode: "+373", timeZone: "UTC +02:00" },
  { name: "Mozambique", phoneCode: "+258", timeZone: "UTC +02:00" },
  { name: "Namibia", phoneCode: "+264", timeZone: "UTC +02:00" },
  { name: "Palestine", phoneCode: "+970", timeZone: "UTC +02:00" },
  { name: "Romania", phoneCode: "+40", timeZone: "UTC +02:00" },
  { name: "Rwanda", phoneCode: "+250", timeZone: "UTC +02:00" },
  { name: "South Africa", phoneCode: "+27", timeZone: "UTC +02:00" },
  { name: "South Sudan", phoneCode: "+211", timeZone: "UTC +02:00" },
  { name: "Sudan", phoneCode: "+249", timeZone: "UTC +02:00" },
  { name: "Swaziland", phoneCode: "+268", timeZone: "UTC +02:00" },
  { name: "Ukraine", phoneCode: "+380", timeZone: "UTC +02:00" },
  { name: "Zambia", phoneCode: "+260", timeZone: "UTC +02:00" },
  { name: "Zimbabwe", phoneCode: "+263", timeZone: "UTC +02:00" },
  { name: "Bahrain", phoneCode: "+973", timeZone: "UTC +03:00" },
  { name: "Belarus", phoneCode: "+375", timeZone: "UTC +03:00" },
  { name: "Comoros", phoneCode: "+269", timeZone: "UTC +03:00" },
  { name: "Djibouti", phoneCode: "+253", timeZone: "UTC +03:00" },
  { name: "Eritrea", phoneCode: "+291", timeZone: "UTC +03:00" },
  { name: "Ethiopia", phoneCode: "+251", timeZone: "UTC +03:00" },
  { name: "Iraq", phoneCode: "+964", timeZone: "UTC +03:00" },
  { name: "Jordan", phoneCode: "+962", timeZone: "UTC +03:00" },
  { name: "Kenya", phoneCode: "+254", timeZone: "UTC +03:00" },
  { name: "Kuwait", phoneCode: "+965", timeZone: "UTC +03:00" },
  { name: "Madagascar", phoneCode: "+261", timeZone: "UTC +03:00" },
  { name: "Mayotte", phoneCode: "+262", timeZone: "UTC +03:00" },
  { name: "Qatar", phoneCode: "+974", timeZone: "UTC +03:00" },
  { name: "Saudi Arabia", phoneCode: "+966", timeZone: "UTC +03:00" },
  { name: "Somalia", phoneCode: "+252", timeZone: "UTC +03:00" },
  { name: "Syria", phoneCode: "+963", timeZone: "UTC +03:00" },
  { name: "Tanzania", phoneCode: "+255", timeZone: "UTC +03:00" },
  { name: "Turkey", phoneCode: "+90", timeZone: "UTC +03:00" },
  { name: "Uganda", phoneCode: "+256", timeZone: "UTC +03:00" },
  { name: "Yemen", phoneCode: "+967", timeZone: "UTC +03:00" },
  { name: "Iran", phoneCode: "+98", timeZone: "UTC +03:30" },
  { name: "Armenia", phoneCode: "+374", timeZone: "UTC +04:00" },
  { name: "Azerbaijan", phoneCode: "+994", timeZone: "UTC +04:00" },
  { name: "Georgia", phoneCode: "+995", timeZone: "UTC +04:00" },
  { name: "Mauritius", phoneCode: "+230", timeZone: "UTC +04:00" },
  { name: "Oman", phoneCode: "+968", timeZone: "UTC +04:00" },
  { name: "Seychelles", phoneCode: "+248", timeZone: "UTC +04:00" },
  { name: "United Arab Emirates", phoneCode: "+971", timeZone: "UTC +04:00" },
  { name: "Afghanistan", phoneCode: "+93", timeZone: "UTC +04:30" },
  { name: "Kazakhstan", phoneCode: "+7", timeZone: "UTC +05:00" },
  { name: "Maldives", phoneCode: "+960", timeZone: "UTC +05:00" },
  { name: "Pakistan", phoneCode: "+92", timeZone: "UTC +05:00" },
  { name: "Tajikistan", phoneCode: "+992", timeZone: "UTC +05:00" },
  { name: "Turkmenistan", phoneCode: "+993", timeZone: "UTC +05:00" },
  { name: "Uzbekistan", phoneCode: "+998", timeZone: "UTC +05:00" },
  { name: "India", phoneCode: "+91", timeZone: "UTC +05:30" },
  { name: "Sri Lanka", phoneCode: "+94", timeZone: "UTC +05:30" },
  { name: "Nepal", phoneCode: "+977", timeZone: "UTC +05:45" },
  { name: "Bangladesh", phoneCode: "+880", timeZone: "UTC +06:00" },
  { name: "Bhutan", phoneCode: "+975", timeZone: "UTC +06:00" },
  {
    name: "British Indian Ocean Territory",
    phoneCode: "+246",
    timeZone: "UTC +06:00",
  },
  { name: "Kyrgyzstan", phoneCode: "+996", timeZone: "UTC +06:00" },
  { name: "Cocos Islands", phoneCode: "+61", timeZone: "UTC +06:30" },
  { name: "Myanmar", phoneCode: "+95", timeZone: "UTC +06:30" },
  { name: "Cambodia", phoneCode: "+855", timeZone: "UTC +07:00" },
  { name: "Christmas Island", phoneCode: "+61", timeZone: "UTC +07:00" },
  { name: "Indonesia", phoneCode: "+62", timeZone: "UTC +07:00" },
  { name: "Laos", phoneCode: "+856", timeZone: "UTC +07:00" },
  { name: "Mongolia", phoneCode: "+976", timeZone: "UTC +07:00" },
  { name: "Thailand", phoneCode: "+66", timeZone: "UTC +07:00" },
  { name: "Vietnam", phoneCode: "+84", timeZone: "UTC +07:00" },
  { name: "Antarctica", phoneCode: "+672", timeZone: "UTC +08:00" },
  { name: "Brunei", phoneCode: "+673", timeZone: "UTC +08:00" },
  { name: "China", phoneCode: "+86", timeZone: "UTC +08:00" },
  { name: "Hong Kong", phoneCode: "+852", timeZone: "UTC +08:00" },
  { name: "Macau", phoneCode: "+853", timeZone: "UTC +08:00" },
  { name: "Malaysia", phoneCode: "+60", timeZone: "UTC +08:00" },
  { name: "Philippines", phoneCode: "+63", timeZone: "UTC +08:00" },
  { name: "Singapore", phoneCode: "+65", timeZone: "UTC +08:00" },
  { name: "Taiwan", phoneCode: "+886", timeZone: "UTC +08:00" },
  { name: "Japan", phoneCode: "+81", timeZone: "UTC +09:00" },
  { name: "Palau", phoneCode: "+680", timeZone: "UTC +09:00" },
  { name: "Guam", phoneCode: "+1-671", timeZone: "UTC +10:00" },
  { name: "Micronesia", phoneCode: "+691", timeZone: "UTC +10:00" },
  {
    name: "Northern Mariana Islands",
    phoneCode: "+1-670",
    timeZone: "UTC +10:00",
  },
  { name: "Australia", phoneCode: "+61", timeZone: "UTC +11:00" },
  { name: "New Caledonia", phoneCode: "+687", timeZone: "UTC +11:00" },
  { name: "Papua New Guinea", phoneCode: "+675", timeZone: "UTC +11:00" },
  { name: "Solomon Islands", phoneCode: "+677", timeZone: "UTC +11:00" },
  { name: "Vanuatu", phoneCode: "+678", timeZone: "UTC +11:00" },
  { name: "Fiji", phoneCode: "+679", timeZone: "UTC +12:00" },
  { name: "Marshall Islands", phoneCode: "+692", timeZone: "UTC +12:00" },
  { name: "Nauru", phoneCode: "+674", timeZone: "UTC +12:00" },
  { name: "Russia", phoneCode: "+7", timeZone: "UTC +12:00" },
  { name: "Tuvalu", phoneCode: "+688", timeZone: "UTC +12:00" },
  { name: "Wallis and Futuna", phoneCode: "+681", timeZone: "UTC +12:00" },
  { name: "Kiribati", phoneCode: "+686", timeZone: "UTC +13:00" },
  { name: "New Zealand", phoneCode: "+64", timeZone: "UTC +13:00" },
  { name: "Samoa", phoneCode: "+685", timeZone: "UTC +13:00" },
  { name: "Tokelau", phoneCode: "+690", timeZone: "UTC +13:00" },
  { name: "Tonga", phoneCode: "+676", timeZone: "UTC +13:00" },
  { name: "Cape Verde", phoneCode: "+238", timeZone: "UTC -01:00" },
  { name: "Portugal", phoneCode: "+351", timeZone: "UTC -01:00" },
  { name: "Argentina", phoneCode: "+54", timeZone: "UTC -03:00" },
  { name: "Brazil", phoneCode: "+55", timeZone: "UTC -03:00" },
  { name: "Chile", phoneCode: "+56", timeZone: "UTC -03:00" },
  { name: "Falkland Islands", phoneCode: "+500", timeZone: "UTC -03:00" },
  { name: "Paraguay", phoneCode: "+595", timeZone: "UTC -03:00" },
  {
    name: "Saint Pierre and Miquelon",
    phoneCode: "+508",
    timeZone: "UTC -03:00",
  },
  { name: "Suriname", phoneCode: "+597", timeZone: "UTC -03:00" },
  { name: "Uruguay", phoneCode: "+598", timeZone: "UTC -03:00" },
  { name: "Anguilla", phoneCode: "+1-264", timeZone: "UTC -04:00" },
  {
    name: "Antigua and Barbuda",
    phoneCode: "+1-268",
    timeZone: "UTC -04:00",
  },
  { name: "Aruba", phoneCode: "+297", timeZone: "UTC -04:00" },
  { name: "Barbados", phoneCode: "+1-246", timeZone: "UTC -04:00" },
  { name: "Bermuda", phoneCode: "+1-441", timeZone: "UTC -04:00" },
  { name: "Bolivia", phoneCode: "+591", timeZone: "UTC -04:00" },
  {
    name: "British Virgin Islands",
    phoneCode: "+1-284",
    timeZone: "UTC -04:00",
  },
  { name: "Curacao", phoneCode: "+599", timeZone: "UTC -04:00" },
  { name: "Dominica", phoneCode: "+1-767", timeZone: "UTC -04:00" },
  {
    name: "Dominican Republic",
    phoneCode: "+1-809, 1-829, 1-849",
    timeZone: "UTC -04:00",
  },
  { name: "Grenada", phoneCode: "+1-473", timeZone: "UTC -04:00" },
  { name: "Guyana", phoneCode: "+592", timeZone: "UTC -04:00" },
  { name: "Montserrat", phoneCode: "+1-664", timeZone: "UTC -04:00" },
  { name: "Puerto Rico", phoneCode: "+1-787, 1-939", timeZone: "UTC -04:00" },
  { name: "Saint Barthelemy", phoneCode: "+590", timeZone: "UTC -04:00" },
  {
    name: "Saint Kitts and Nevis",
    phoneCode: "+1-869",
    timeZone: "UTC -04:00",
  },
  { name: "Saint Lucia", phoneCode: "+1-758", timeZone: "UTC -04:00" },
  { name: "Saint Martin", phoneCode: "+590", timeZone: "UTC -04:00" },
  {
    name: "Saint Vincent and the Grenadines",
    phoneCode: "+1-784",
    timeZone: "UTC -04:00",
  },
  { name: "Sint Maarten", phoneCode: "+1-721", timeZone: "UTC -04:00" },
  {
    name: "Trinidad and Tobago",
    phoneCode: "+1-868",
    timeZone: "UTC -04:00",
  },
  {
    name: "U.S. Virgin Islands",
    phoneCode: "+1-340",
    timeZone: "UTC -04:00",
  },
  { name: "Venezuela", phoneCode: "+58", timeZone: "UTC -04:00" },
  { name: "Bahamas", phoneCode: "+1-242", timeZone: "UTC -05:00" },
  { name: "Canada", phoneCode: "+1", timeZone: "UTC -05:00" },
  { name: "Cayman Islands", phoneCode: "+1-345", timeZone: "UTC -05:00" },
  { name: "Colombia", phoneCode: "+57", timeZone: "UTC -05:00" },
  { name: "Cuba", phoneCode: "+53", timeZone: "UTC -05:00" },
  { name: "Haiti", phoneCode: "+509", timeZone: "UTC -05:00" },
  { name: "Jamaica", phoneCode: "+1-876", timeZone: "UTC -05:00" },
  { name: "Panama", phoneCode: "+507", timeZone: "UTC -05:00" },
  { name: "Peru", phoneCode: "+51", timeZone: "UTC -05:00" },
  {
    name: "Turks and Caicos Islands",
    phoneCode: "+1-649",
    timeZone: "UTC -05:00",
  },
  { name: "Belize", phoneCode: "+501", timeZone: "UTC -06:00" },
  { name: "Costa Rica", phoneCode: "+506", timeZone: "UTC -06:00" },
  { name: "Ecuador", phoneCode: "+593", timeZone: "UTC -06:00" },
  { name: "El Salvador", phoneCode: "+503", timeZone: "UTC -06:00" },
  { name: "Guatemala", phoneCode: "+502", timeZone: "UTC -06:00" },
  { name: "Honduras", phoneCode: "+504", timeZone: "UTC -06:00" },
  { name: "Nicaragua", phoneCode: "+505", timeZone: "UTC -06:00" },
  { name: "Mexico", phoneCode: "+52", timeZone: "UTC -08:00" },
  { name: "Pitcairn", phoneCode: "+64", timeZone: "UTC -08:00" },
  { name: "French Polynesia", phoneCode: "+689", timeZone: "UTC -09:00" },
  { name: "Cook Islands", phoneCode: "+682", timeZone: "UTC -10:00" },
  { name: "United States", phoneCode: "+1", timeZone: "UTC -10:00" },
  { name: "American Samoa", phoneCode: "+1-684", timeZone: "UTC -11:00" },
  { name: "Niue", phoneCode: "+683", timeZone: "UTC -11:00" },
  { name: "East Timor", phoneCode: "+670", timeZone: "UTC +09:00" },
];
